import { render } from "./search-enrolments-bar.vue?vue&type=template&id=aa6a2d1a&ts=true"
import script from "./search-enrolments-bar.ts?vue&type=script&lang=ts&external"
export * from "./search-enrolments-bar.ts?vue&type=script&lang=ts&external"

import "./search-enrolments-bar.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__